"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.VRCSpineMode = void 0;
var VRCSpineMode;
(function (VRCSpineMode) {
    VRCSpineMode[VRCSpineMode["UNKNOWN"] = 0] = "UNKNOWN";
    VRCSpineMode[VRCSpineMode["LOCK_HIP"] = 1] = "LOCK_HIP";
    VRCSpineMode[VRCSpineMode["LOCK_HEAD"] = 2] = "LOCK_HEAD";
    VRCSpineMode[VRCSpineMode["LOCK_BOTH"] = 3] = "LOCK_BOTH";
})(VRCSpineMode = exports.VRCSpineMode || (exports.VRCSpineMode = {}));
